/* eslint-disable react/no-children-prop */

import React, { useState } from 'react'
import { NavLink, useMatch } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import RoundedIcon from '~components/ui/RoundedIcon'
import { isScreenSize } from '~helpers/mediaQuery'
import Logout from '~components/helpers/Logout'
import { getAvailableCredit, getCreditLimit } from '~helpers/price'
import Sprite from '~components/Sprite'

const AccountMenuItem = ({ link, toggleNav, stockist }) => {
  const [open, setOpen] = useState(false)
  const [logout, setLogout] = useState(false)
  const customerNumber = stockist.customer_number.replace('{[BS]}', '')
  const match = useMatch(`${link}/*`)
  const isActive = !!match

  const items = [
    {
      title: 'Stockist Code',
      value: stockist?.customer_number
    },
    {
      title: 'Stockist Name',
      value: stockist?.name
    },
    {
      title: 'Drop Seq',
      value: stockist?.sequence_number
    },
    {
      title: 'Credit Limit',
      value: `${stockist?.credit?.creditLimit}`
    }
  ]

  const toggleDropdown = () => {
    setOpen(!open)
  }

  const handleNavDropdown = (e) => {
    if (items) {
      toggleDropdown()

      if (!isScreenSize('lg')) {
        e.preventDefault()
      }
    } else {
      toggleNav()
    }
  }

  return (
    <>
      {logout && <Logout />}

      <NavLink
        to="/account"
        className="relative flex items-center lg:h-full lg:px-6 xl:px-10 lg:-ml-6 xl:-ml-10"
        onClick={handleNavDropdown}
      >
        <RoundedIcon
          name="user"
          className="block w-7 h-7"
          active={isActive}
        />

        <span className="block w-auto ml-2">
          <span className="block text-base">
            {`${stockist.name} ${customerNumber} ${stockist.sequence_number}`}
          </span>

          <span className="block text-xxs">
            {'Available Credit: '}

            <strong>
              {getAvailableCredit(stockist)}
            </strong>
          </span>
        </span>

        {items && (
        <span
          aria-hidden="true" className={classNames(
            'hidden lg:absolute lg:bottom-0 h-0 w-0 absolute border-r-10 border-l-10 border-b-10 border-triangle lg:block lg:transition-all lg:duration-200 lg:ease-in-out'
          )}
        >
        </span>
        )}
      </NavLink>

      {items && (
      <div className={classNames(
        'bg-pink py-10 relative mt-6 extend-bg-left extend-bg-right max-height-0 lg:p-0 lg:absolute lg:w-full lg:left-0 lg:right-0 lg:mt-0 lg:top-full lg:flex lg:py-1 lg:transition-all lg:duration-200 lg:ease-in-out',
        { block: open },
        { hidden: !open }
      )}
      >
        <ul
          className="xxl:container lg:w-full lg:mx-auto lg:px-8 lg:flex xxl:px-0"
        >
          <span aria-hidden="true" className="absolute left-0 block w-0 h-0 -top-3 border-r-10 border-l-10 border-b-10 border-triangle lg:hidden"></span>

          {items.map((child, index) => {
            if (child.title === 'Credit Limit') {
              return (
                <li key={index} className="mb-2">
                  {`${child.title}: `}
                  <strong>
                    {getCreditLimit(stockist)}
                  </strong>
                </li>
              )
            } else {
              return (
                <li
                  className={classNames('lg:mt-0 lg:mr-6', { 'mt-2': index > 0 })}
                  key={index}
                >
                  {`${child.title}: `}

                  <strong>
                    {child.value}
                  </strong>
                </li>
              )
            }
          })}

          <li className="pt-6 mt-6 border-t lg:mt-0 lg:mr-6 border-charcoal">
            <a
              href="/account"
              className="block"
            >
              View Account
            </a>
          </li>

          <li className="mt-2 lg:mt-0 lg:mr-6">
            <button
              type="button"
              className="flex items-center"
              onClick={() => setLogout(true)}
            >
              Log out

              <span
                className="block w-5 h-5 ml-2 icon icon-fill"
                aria-hidden
              >
                <Sprite name="exit" />
              </span>
            </button>
          </li>
        </ul>
      </div>
      )}
    </>
  )
}

AccountMenuItem.propTypes = {
  toggleNav: PropTypes.func,
  link: PropTypes.string,
  stockist: PropTypes.object
}

const mapStateToProps = (state) => ({
  stockist: state.auth.account.stockist
})

export default connect(mapStateToProps)(AccountMenuItem)
